export const GET_NOTIFICATIONS = 'getNotifications'
export const SET_NOTIFICATIONS = 'setNotifications'
export const MARK_AS_READ_NOTIFICATIONS = 'markAsReadNotifications'
export const SET_MENU_BADGE_COUNTER = 'setMenuBadgeCounter'
export const GET_MENU_TOTAL_BADGE_COUNTER = 'getMenuTotalBadgeCounter'
export const GET_MENU_BADGE_COUNTER = 'getMenuBadgeCounter'